import UpdateLicense from './UpdateLicense'

export default UpdateLicense
